import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const KEY = "flycup_session";

export const getSession = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch {
    return null;
  }
};
export const setSession = (s) => localStorage.setItem(KEY, JSON.stringify(s));
export const isAdmin = () => isLoggedIn() && getSession()?.role === "admin";
export const clearSession = () => localStorage.removeItem(KEY);
export const isLoggedIn = () => {
  const s = getSession();
  if (!s?.token) return false;
  try {
    const { exp } = JSON.parse(atob(s.token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return !exp || exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const s = getSession();
  if (s?.token) cfg.headers.Authorization = `Bearer ${s.token}`;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && getSession() && !err.config.url.includes("/auth/")) {
      const role = getSession()?.role;
      clearSession();
      window.location.href = { admin: "/admin/login", registrar: "/rejestracja/login", announcer: "/konferansjer/login", diploma: "/dyplomy/login" }[role] || "/sedzia/login";
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  const st = e?.response?.status;
  if (!e?.response) return "Brak połączenia z serwerem. Sprawdź internet i spróbuj ponownie.";
  return `Wystąpił błąd serwera (kod ${st}). Spróbuj ponownie.`;
};

export const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.rel = "noopener"; a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { a.remove(); URL.revokeObjectURL(url); }, 60000);
};

export const downloadFile = async ({ path, params = {}, filename, auth = true, win }) => {
  if (win || window.self !== window.top) {
    win = win || window.open("", "_blank");
    try {
      const q = new URLSearchParams(params);
      if (auth) q.set("dl", (await api.post("/auth/download-token")).data.token);
      win.location.href = `${API}${path}?${q.toString()}`;
    } catch (e) {
      win?.close();
      throw e;
    }
    return;
  }
  const r = await api.get(path, { params, responseType: "blob" });
  saveBlob(r.data, filename);
};

export const MEDIA_LABEL = { music: "Muzyka", music_photo: "Muzyka + zdjęcie", video: "Animacja" };

export const fmt = (n) => (Number.isInteger(n) ? String(n) : Number(n).toFixed(1).replace(".", ","));

export const dayLabel = (d) => d.charAt(0) + d.slice(1).toLowerCase();
